<template>
  <v-container fluid tag="section" :class="$isMobile ? 'pa-0' : 'pa-0'">
    <v-tabs v-model="tab" v-bind='$attrs'>
      <v-tab>专利详情</v-tab>
      <v-tab>流程记录</v-tab>
      <v-tab>客户详情</v-tab>
      <v-tab>合同详情</v-tab>
      <v-tab>年费记录</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <detail-view mini :item='item' @on-load-data='loadData'></detail-view>
      </v-tab-item>
      <v-tab-item>
        <record-detail  mini :item='item.recordList'></record-detail>
      </v-tab-item>
      <v-tab-item>
        <customer-detail mini :item='item.customer' lazy></customer-detail>
      </v-tab-item>
      <v-tab-item>
        <contract-view mini :item='item.contract' lazy></contract-view>
      </v-tab-item>
        <v-tab-item>
        <cost-detail mini :item='item.patentCostList' @on-load-data='loadData'></cost-detail>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
  import CustomerDetail from '@/views/pages/pc/customer/components/Detail.vue'
  import ContractView from '@/views/pages/pc/contract/info/components/Detail.vue'
  import CostDetail from '@/views/pages/pc/patent/cost/components/Detail.vue'
  import DetailView from './components/Detail.vue'
  import RecordDetail from './components/RecordDetail.vue'

  export default {
    name: 'PatentDetailIndex',
    components: {
      DetailView,
      CostDetail,
      RecordDetail,
      ContractView,
      CustomerDetail,
    },
    props: {
      item: {
        type: Object,
        default: () => ({})
      }
    },
    data() {
      return {
        tab: 0
      }
    },
    methods: {
      loadData () {
        this.$emit("on-load-data")
      }
    }
  }
</script>

<style>
</style>
